import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M13.675 5.068c-7.097-.383-7.29 8.29-7.29 8.29l-3.25 2.478a.4.4 0 0 0-.135.293c0 .225.174.383.348.338a7.7 7.7 0 0 1 2.534-.158c1.14.113 2.282.878 2.9 1.374.445.36.948.608 1.49.676 0 0 5.337 1.014 4.602-3.312"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M6.384 13.358s1.393-.045 2.205 0 2.824.676 3.675.969c.87.292 2.494.743 6.092.856.696.022.812-.541.812-.541s.348-3.109-.638-5.79c0 0-1.354-3.807-3.404-1.351-2.32 2.793 3.114 5.159 5.705 1.284"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M9.653 13.335S9.769 6.284 13.54 5"
    />
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M18.356 15.183c.696.022.812-.541.812-.541s.348-3.109-.638-5.79c0 0-1.354-3.807-3.404-1.351-2.32 2.793 3.114 5.159 5.705 1.284"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const TeenIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
